// extracted by mini-css-extract-plugin
export default {"ApplestoreImg":"SharedButtons_ApplestoreImg__lyGlP","GoogleplayStoreImg":"SharedButtons_GoogleplayStoreImg__0BAnb"};